const padLeft = (character, length, number = 0) => String(character).padStart(length, number);

export default padLeft;
